module.exports = __webpack_public_path__ + "logo_colegio.svg?8a24ce7e3a9041eda92ddea6eb07114e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_colegio.svg
// module id = 19
// module chunks = 0